var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelatedResearches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.648 90.024h240.875v30H193.648zM193.648 391.627h120.375v30H193.648z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.398 0v169.677c-27.223 19.058-45.062 50.645-45.062 86.324 0 23.637 7.829 45.479 21.027 63.072l-92.134 92.134 21.213 21.213 92.134-92.134c.928.696 1.871 1.373 2.822 2.039v169.677h274.338l87.037-87.037V0zm60.25 180.688c41.528 0 75.313 33.785 75.313 75.312s-33.785 75.312-75.313 75.312c-41.527 0-75.312-33.785-75.312-75.312s33.784-75.312 75.312-75.312zm-30.25 176.191c9.586 2.88 19.739 4.435 30.25 4.435v.063h240.875v-30H267.114c8.899-8.675 16.273-18.905 21.675-30.25h145.734v-30H297.87c.714-4.941 1.091-9.99 1.091-15.126 0-5.135-.377-10.183-1.09-15.124h136.653v-30H288.79c-5.439-11.422-12.876-21.714-21.855-30.426h167.588v-30H193.648v.238c-10.511 0-20.664 1.555-30.25 4.435V30h301.375v361.627h-90.375v90.375h-211zm241 116.035v-51.287h51.287z",
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedResearches);
export default __webpack_public_path__ + "static/media/related-researches.9c453eaf52e31eab180351ba78b9007a.svg";
export { ForwardRef as ReactComponent };